export const validateEmptyValueAndNewLines = (value: string | undefined) => {
  if (!value) {
    return true
  }
  // Use a regular expression to check for special characters
  return !value.includes('\n')
}
